import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { BarChart } from '@mui/x-charts/BarChart';
import ColorsContext from './ColorsContext';
import RegionHeader from './RegionHeader';
import ISLTable from './ISLTable';

const StreamflowGrf = (props) => { 
  const { smallScreen } = props;
  const { levelColors } = useContext(ColorsContext);
  const [ sfdata, setSfdata ] = useState([]);
  const [ gagecnt, setGagecnt ] = useState(0);

  const barColors = [
    levelColors[4], 
    levelColors[3], 
    levelColors[2], 
    levelColors[1], 
    "rgb(102, 255, 100)",
  ];
  const legendColors = {
        4: levelColors[4],
        3: levelColors[3],
        2: levelColors[2],
        1: levelColors[1],
        0: "rgb(102, 255, 100)"
  };

  const buttonValue = "sfpcttable";

  const dataFileName = (window.location.hostname === "localhost" ? "." : "/ma") + "/data/sf_pctl_daily.json";

  useEffect(() => {
    axios.get(dataFileName) 
      .then(json => {
        setSfdata(json.data);
        const sum = json.data.slice(-1)[0].count;
        if (sum) {
          setGagecnt(sum);
        }
      })
      .catch(err => console.error("Fetch error retrieving sf_pctl_daily data:", err));
  }, [dataFileName]);

  return (
    <>
      <RegionHeader
        title={"Streamflow Summary"}
        buttontext={"Table View"}
        buttonValue={buttonValue}
        handleButtonClick={props.handleButtonClick}
        addtext={""}
      />
      {sfdata.length > 0 ?
        <div id="grfimage" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Typography sx={{ fontSize: "18px" }}>
              Percent of Gages at Index Severity Level
            </Typography>
           <Typography variant="subtitle2" sx={{ fontStyle: 'italic', marginBottom: '-1em' }}>
              based on data from {gagecnt} streamflow gages
            </Typography>
            <BarChart
              dataset={sfdata}
              xAxis={[{ 
                scaleType: 'band', 
                dataKey: 'date', 
                categoryGapRatio: 0,
                tickLabelInterval: (value, index) => index % 3 === 0,
               }]}
              yAxis={[{
                label: 'Percent of Gages',
                max: 100,
              }]}
              series={[
                { dataKey: 'level4', label: 'Level 4: \u22642 percentile', stack: 'total', valueFormatter: (v) => (v === null ? '' :  v + '%') },
                { dataKey: 'level3', label: 'Level 3: 2-10 percentile', stack: 'total', valueFormatter: (v) => (v === null ? '' :  v + '%') },
                { dataKey: 'level2', label: 'Level 2: 10-20 percentile', stack: 'total', valueFormatter: (v) => (v === null ? '' :  v + '%') },
                { dataKey: 'level1', label: 'Level 1: 20-30 percentile', stack: 'total', valueFormatter: (v) => (v === null ? '' :  v + '%') },
                { dataKey: 'level0', label: 'Level 0: >30 percentile', stack: 'total', valueFormatter: (v) => (v === null ? '' :  v + '%') },
               ]}
              colors={barColors}
              slotProps={{ legend: { hidden: true } }}
              grid={{ horizontal: true }}
              height={Math.min((window.innerHeight * 0.67), 780)}
              width={window.innerWidth - (smallScreen ? 0 : 200) - 32}
            />
            <ISLTable 
              colors={legendColors}
            />
        </div>
      :
        <>
          <CircularProgress />
          <span>Loading ...</span>
        </>
    }
    </>
  );
}

export default StreamflowGrf;
